export default "__VITE_ASSET__C6ULk0Ex__"